import { render, staticRenderFns } from "./OvertimeRules.vue?vue&type=template&id=6705b4ee&scoped=true&"
import script from "./OvertimeRules.vue?vue&type=script&lang=js&"
export * from "./OvertimeRules.vue?vue&type=script&lang=js&"
import style0 from "./OvertimeRules.vue?vue&type=style&index=0&id=6705b4ee&lang=scss&scoped=true&"
import style1 from "./OvertimeRules.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705b4ee",
  null
  
)

export default component.exports